/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SummarizationsControllerGetFileContentQueryResponse, SummarizationsControllerGetFileContentPathParams, SummarizationsControllerGetFileContent404 } from "../../models/documentSummariesController/SummarizationsControllerGetFileContent";

function getSummarizationsControllerGetFileContentUrl(documentId: SummarizationsControllerGetFileContentPathParams["documentId"], renditionId: SummarizationsControllerGetFileContentPathParams["renditionId"], summaryId: SummarizationsControllerGetFileContentPathParams["summaryId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/summaries/${summaryId}/content` as const }  
  return res
}

/**
 * @description Retrieves the actual text content of a summary. First checks the database for inline content, then falls back to S3 storage if a storage location is specified.
 * @summary Get summary content
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/summaries/:summaryId/content}
 */
export async function summarizationsControllerGetFileContent(documentId: SummarizationsControllerGetFileContentPathParams["documentId"], renditionId: SummarizationsControllerGetFileContentPathParams["renditionId"], summaryId: SummarizationsControllerGetFileContentPathParams["summaryId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SummarizationsControllerGetFileContentQueryResponse, ResponseErrorConfig<SummarizationsControllerGetFileContent404>, unknown>({ method : "GET", url : getSummarizationsControllerGetFileContentUrl(documentId, renditionId, summaryId).url.toString(), ... requestConfig })  
  return res.data
}